import { useLocale } from 'next-intl';

import { FullLocale, Locale } from '@/types/locale';

interface CurrentLocale {
  short: Locale;
  full: FullLocale;
}

const useCurrentLocale = () => {
  const l = useLocale() || Locale.Fr;

  return {
    short: l as Locale,
    full: `${l.toUpperCase()}-${l}` as FullLocale,
  };
};

export type { CurrentLocale };
export { useCurrentLocale };
